module.exports = __webpack_public_path__ + "static/img/xubin.89fbb36.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/haibao_h5/xubin.jpg
// module id = zy8W
// module chunks = 0